import { render, staticRenderFns } from "./DemoTableTheme.vue?vue&type=template&id=8e11a558&scoped=true"
import script from "./DemoTableTheme.vue?vue&type=script&lang=js"
export * from "./DemoTableTheme.vue?vue&type=script&lang=js"
import style0 from "./DemoTableTheme.vue?vue&type=style&index=0&id=8e11a558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e11a558",
  null
  
)

export default component.exports